import AbstractModelType from '../AbstractModelType';
import BookLocation from '../BookLocation';

// A page represents a segment of content in a book, delineated by page breaks.
// It is the same as "EpubPage" on the backend and reflected in the page list in source epubs.
class BookPage extends AbstractModelType {
  book;
  index;
  label;
  element;
  markerIndices;
  documentIndices;
  characterCount;
  percentageStart; // at what percentage through the book does this page appear
  percentageEnd; // at what percentage throught the book does this page end
  #documents;
  #markers;

  constructor({ ...properties }) {
    super(...arguments);

    this.index = properties.index;
    this.label = properties.label;
    this.element = properties.element;
    this.characterCount = properties.characterCount;

    this.documentIndices =
      properties.documentIndices ?? properties.documentIndicies ?? [];
    this.documentIndices.sort((a, b) => a - b);

    this.markerIndices =
      properties.markerIndices ?? properties.markerIndicies ?? [];
    this.markerIndices.sort((a, b) => a - b);
  }

  get bookLocation() {
    return new BookLocation({ page: this });
  }

  get previous() {
    return this.book.pages[this.index - 1] ?? null;
  }

  get next() {
    return this.book.pages[this.index + 1] ?? null;
  }

  get documents() {
    if (this.#documents) {
      return this.#documents;
    }

    const documents = [];

    for (let documentIndex of this.documentIndicies) {
      documents.push(this.book.documents[documentIndex]);
    }

    this.#documents = documents;

    return this.#documents;
  }

  get documentIndicies() {
    // alias spelling error
    return this.documentIndices;
  }

  get document() {
    return this.documents[0] ?? null;
  }

  get markerIndicies() {
    // alias spelling error
    return this.markerIndices;
  }

  get markers() {
    if (this.#markers) {
      return this.#markers;
    }

    const markers = [];

    for (let markerIndex of this.markerIndices) {
      markers.push(this.book.markers[markerIndex]);
    }

    this.#markers = markers;

    return this.#markers;
  }

  get marker() {
    return this.markers[0] ?? null;
  }

  get percentage() {
    return this.percentageEnd - this.percentageStart;
  }

  setDerivedProperties() {
    return [this.documents, this.markers];
  }
}

export default BookPage;
